<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { Workspace, WorkspaceUser } from '../../../types/workspace';
import { UserRole, UserRoleType } from '../../../types/user_role';

const props = defineProps<{
  show: boolean;
  workspace?: Workspace;
  workspaceUser?: WorkspaceUser;
}>();
const roles: UserRoleType[] = [UserRole.Owner];

const showLink = computed(() => props.workspaceUser && roles.includes(props.workspaceUser.role));
</script>

<template>
  <div v-if="props.show" class="mt-s flex h-[72px] items-center justify-center rounded-12 bg-error-light">
    <div class="flex items-center gap-s">
      <span>🙁 You have reached the limit for the cloud storage </span>

      <router-link v-if="props.workspace && showLink" :to="`/w/${props.workspace.short_link}`">
        <span class="button button-colored h-[32px] !px-m">
          <span class="button__text">Get Storage</span>
        </span>
      </router-link>
    </div>
  </div>
</template>
